import { z } from "zod"

export const maintenanceRecordRecordSchema = z.object({
    id: z.uuid(),
    org_id: z.uuid(),
    template_id: z.uuid(),
    aircraft_id: z.uuid(),
    date_performed: z.string(),
    performed_by: z.guid().nullable(),
    notes: z.string().nullable(),
    skipped: z.boolean(),
    created_by: z.guid(),
    created_at: z.string(),
})

export const maintenanceRecordSchema = maintenanceRecordRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    templateId: r.template_id,
    aircraftId: r.aircraft_id,
    datePerformed: r.date_performed,
    performedBy: r.performed_by,
    notes: r.notes,
    skipped: r.skipped,
    createdBy: r.created_by,
    createdAt: r.created_at,
}))

export const creatableMaintenanceRecordSchema = maintenanceRecordRecordSchema.omit({
    id: true,
    org_id: true,
    created_at: true,
    created_by: true,
})

export const updatableMaintenanceRecordSchema = maintenanceRecordRecordSchema
    .omit({ id: true, org_id: true, created_at: true, created_by: true })
    .partial()

export type MaintenanceRecordRecord = z.infer<typeof maintenanceRecordRecordSchema>
export type MaintenanceRecord = z.infer<typeof maintenanceRecordSchema>
export type CreatableMaintenanceRecord = z.infer<typeof creatableMaintenanceRecordSchema>
export type UpdatableMaintenanceRecord = z.infer<typeof updatableMaintenanceRecordSchema>
